/*
 *  TTTech nerve-ui-components
 *  Copyright(c) 2021. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

// eslint-disable-next-line import/no-extraneous-dependencies
import semver from 'semver';

export default {
  getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  },
  isObject(entity) {
    return typeof entity === 'object' && entity !== null;
  },
  dateFormatByLanguage(value) {
    // TODO Change format of date by selected language
    return new Date(value).getDate()
      ? new Date(value).toLocaleDateString(['en-EN'], {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      : value;
  },
  versionWithoutPrereleaseTags(version) {
    if (!version || !semver.valid(version)) {
      return null;
    }
    const prereleaseTags = semver.prerelease(version);
    if (!prereleaseTags) {
      return version;
    }
    const major = semver.major(version);
    const minor = semver.minor(version);
    const patch = semver.patch(version);

    return `${major}.${minor}.${patch}`;
  },
  isNoPrerelesedVersionGreaterThanOrEqualTo(version, referenceVersion) {
    const nodeVersion = this.versionWithoutPrereleaseTags(version);
    return nodeVersion && semver.gte(nodeVersion, referenceVersion);
  },
};
